"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";
import { Collections } from "../data/collections";

const formatDateToFrench = (dateStr: string) => {
  const [month, year] = dateStr.split("/");
  const months = {
    "01": "Janvier",
    "02": "Février",
    "03": "Mars",
    "04": "Avril",
    "05": "Mai",
    "06": "Juin",
    "07": "Juillet",
    "08": "Août",
    "09": "Septembre",
    "10": "Octobre",
    "11": "Novembre",
    "12": "Décembre",
  };

  return `${months[month as keyof typeof months]} 20${year}`;
};

const OtherCollections: React.FC = () => {
  // Get all collections except the most recent one, sorted by date descending
  const otherCollections = [...Collections]
    .sort((a, b) => {
      const [monthA, yearA] = a.date.split("/").map(Number);
      const [monthB, yearB] = b.date.split("/").map(Number);
      if (yearA !== yearB) return yearB - yearA;
      return monthB - monthA;
    })
    .slice(1); // Remove the most recent one, keep the sort order (newest to oldest)

  return (
    <div className="w-full px-4 py-16 ph:px-24 md:px-48 lg:px-72 xl:px-96">
      <h2 className="mb-12 font-cormorant text-4xl ph:text-5xl sm:text-6xl lg:mb-16 lg:text-7xl">
        AUTRES COLLECTIONS
      </h2>
      <div className="grid gap-16 md:grid-cols-2 lg:grid-cols-3">
        {otherCollections.map((collection, index) => (
          <Link
            href={`/collections/${collection.id}`}
            key={index}
            className="group"
          >
            <div className="flex flex-col gap-4">
              <div className="relative aspect-square w-full overflow-hidden">
                <Image
                  src={collection.images[0]}
                  alt={collection.title}
                  fill
                  sizes="(max-width: 768px) 100vw, 50vw"
                  className="object-cover transition-transform duration-500 ease-out group-hover:scale-105 group-hover:grayscale"
                />
              </div>
              <div className="flex flex-col items-center text-center">
                <h2 className="text-2xl uppercase">{collection.title}</h2>
                <p className="text-sm text-gray-600">
                  {formatDateToFrench(collection.date)}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default OtherCollections;
